export const GLOBAL_MIN_DATE = "1850-01-01"
export const GLOBAL_MIN_YEAR = 1850
